import { RootState } from "@store/store";
import { useSelector } from "react-redux";

const Loader = () => {
  const loading = useSelector((state: RootState) => state.loader.loading);

  if (!loading) return null;

  return (
    <div className="overlay-loader" role="status" aria-label="Loading">
      <div className="spinner" aria-hidden="true"></div>
    </div>
  );
};

export default Loader;
